export default function (nga, admin) {
    let entity = admin.getEntity('interested')
        .label('INTERESTED')
    //.readOnly();

    entity.listView()
        .fields([
            nga.field('name').label('NAME').detailLinkRoute('show').isDetailLink(true),
            nga.field('surname').label('SURNAME').detailLinkRoute('show').isDetailLink(true),
            nga.field('email').label('EMAIL').detailLinkRoute('show').isDetailLink(true),
            nga.field('phone').label('PHONE').detailLinkRoute('show').isDetailLink(true),
            nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd / HH:mm')
        ])
        .sortDir('asc')
        .url('interesteds');

    entity.showView().fields([
        nga.field('id'),
        nga.field('name').label('NAME'),
        nga.field('surname').label('SURNAME'),
        nga.field('email').label('EMAIL'),
        nga.field('phone').label('PHONE'),
        nga.field('comment').label('COMMENT'),
        nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd / HH:mm')
    ]);

    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/interested/config.js
 **/